module.exports = __webpack_public_path__ + "img/ring_y_l_null_1@2x.88786902.png";